import "./EpiserverForms/Extensions/ExtendedClientScriptValidator";

import "./vendor/custom-elements";
import "./vendor/inert";
import "./vendor/modernizr";

import "./Application.Cookies";
import "./application.enhancers";
import "./Application.QueryString";
import "./Application.Utils";
import "./Application.Validation";

import "./ArrangementSearch";
import "./offcanvasmenu";
import "./SearchHistoryManager";
import "./SearchOverlay";
import "./VideoControl";
import "./MegaMenu";
import "./MobileMegaMenu";

import "./enhancers/arrangementFilter";
import "./enhancers/arrangementSearchBox";
import "./enhancers/customFileUpload";
import "./enhancers/dismissableToast";
import "./enhancers/expandableForm";
import "./enhancers/getDynamicHeight";
import "./enhancers/globalHeader";
import "./enhancers/LoadingButton";
import "./enhancers/localCoursedatesFilter";
import "./enhancers/localListSearch";
import "./enhancers/locationAutoComplete";
import "./enhancers/locationSearchOverlay";
import "./enhancers/minorToggler";
import "./enhancers/modalHelper";
import "./enhancers/newsList";
import "./enhancers/querySearchOverlay";
import "./enhancers/smoothScroll";
import "./enhancers/faq-toggle";

import "./webcomponents/video-wrapper";

/*-------------------------------------------
  DOCUMENT READY FUNCTIONS
  All functions to be called on
  doc ready
-------------------------------------------*/
$(function () {
    $('.toast').toast();
});

(function ($) {

    var $jQval = $.validator;

    $jQval.addMethod("requiredif",
        function (value, element, parameters) {
            try {
                var names = element.name.split(".");
                names[names.length - 1] = parameters.othername;
                var name = names.join(".");
                var otherValue = element.form[name].value;
                var expectedValue = element.dataset.valRequiredifOthervalues;
                if (otherValue == expectedValue) {
                    return value != "";
                }
            } catch (error) {
                console.error("requiredIf error: ", error);
            }
            return true;
        }
    );

    var adapters = $jQval.unobtrusive.adapters;
    adapters.addBool('requirediftrue');

})(jQuery);

// Workaround to trigger validation on text inputs on various events, including validation on empty fields
(function ($) {
    $("form input[type='text'],form input[type='email'],form input[type='tel']").on('blur keyup change input',
        (e) => {
            $(e.target).valid();
        });
})(jQuery);